import { useEffect, useMemo, useState } from 'react';
import { getCaseStage } from 'services/case/caseServices';
import { totalCountEvent } from 'services/generalServices';

export function useCaseStageList(excludeFromLoading = false, practice_area = '') {
  const [caseStageList, setCaseStageList] = useState([]);
  const [isStagesLoading, setIsStagesLoading] = useState(false);

  const loadStageList = (practice_area = false) => {
    setIsStagesLoading(true);
    totalCountEvent('case-stage')
      .then((response) => {
        getCaseStage({ practice_area, pageLimit: response?.data ?? 10, excludeFromLoading })
          .then((response) => setCaseStageList(response?.data?.case_stage))
          .catch((error) => console.log(error))
          .finally(() => setIsStagesLoading(false));
      })
      .catch((err) => {
        setIsStagesLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    loadStageList(practice_area);
  }, [practice_area]);

  const caseStageOptions = useMemo(() => {
    if (caseStageList?.length) {
      let data = [];
      caseStageList.forEach((val) => {
        data.push({
          label: val.stage_name,
          value: val.stage_name,
        });
      });
      return data;
    } else {
      return [];
    }
  }, [caseStageList]);

  return { caseStageList, loadStageList, caseStageOptions, isStagesLoading };
}
